// removed by extract-text-webpack-plugin
module.exports = {"Topbread":"index__Topbread__31vBg","createBtn":"index__createBtn__4YtSY","pageTop":"index__pageTop__3CtDX","pageTitle":"index__pageTitle__C-r9z","cardList":"index__cardList__3UaqE","card":"index__card__2hfl4","item":"index__item__smcKe","extraImg":"index__extraImg__3OrRD","_list_link_to":"index___list_link_to__21p5s","newButton":"index__newButton__1qM_Y","cardAvatar":"index__cardAvatar__3Cae5","cardDescription":"index__cardDescription__36UhR","pageHeaderContent":"index__pageHeaderContent__3DoX1","contentLink":"index__contentLink__3Lv1B"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Categories/Form/index.less
// module id = 1309
// module chunks = 0